import React from "react";
import { PiPencilSimpleLineThin } from "react-icons/pi";
import { FaSearch } from "react-icons/fa";
import { BsChatRightDots } from "react-icons/bs";

const chatData = [
  {
    icon: <FaSearch className="mx-auto" />,
    mainPrompt: "Discover",
    prompt1: "Hi, I'm really worried about the lack of public parks in our area. My kids have nowhere safe to play.",
    // prompt2: "Tell me more about gun control policies",
  },
  {
    icon: <PiPencilSimpleLineThin className="mx-auto" />,
    mainPrompt: "Generate",
    prompt1:"Affordable housing is becoming impossible. The rent keeps going up.",
    // prompt2: "Generate a policy based on our conversation today",
  },
  {
    icon: <BsChatRightDots className="mx-auto" />,
    mainPrompt: "Chats",
    prompt1: "The street lighting is terrible. It's scary at night.",
    // prompt2: "Let’s talk policies today!",
  },
];

export default chatData;
